<script setup>
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';
import ApplicationLogo from '@/Components/Shared/ApplicationLogo.vue';
import DeBestelAppHead from '@/Components/Shared/DeBestelAppHead.vue';

const props = defineProps({
    status: Number
});

const title = computed(() => {
    return {
        503: 'Wij zijn momenteel bezig met een update',
        500: 'Interne serverfout',
        404: '404: Niet gevonden',
        403: '403: Verboden toegang',
    }[props.status];
});

const description = computed(() => {
    return {
        503: 'Beste klant, wij zijn momenteel bezig met het updaten van onze systeem. Kom over enkele minuten terug en probeer het nogmaals.',
        500: 'Whoops, er is iets mis gegaan op onze servers. Wij krijgen hier een automatische bericht van en gaan het probleem zo snel mogelijk oplossen.',
        404: 'Sorry, de pagina die je probeert te bezoeken bestaat niet (meer).',
        403: 'Sorry, je hebt geen toegang tot deze pagina.',
    }[props.status];
});
</script>

<template>
    <DeBestelAppHead title="Error" />

    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
        <div>
            <Link href="/">
                <ApplicationLogo class="w-full fill-current text-gray-500 h-16" />
            </Link>
        </div>

        <div class="w-full sm:max-w-xl mt-12 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <h2 class="font-semibold text-2xl leading-tight mb-4">{{ title }}</h2>
            <h3 class="font-semibold text-lg leading-tight mb-4">{{ description }}</h3>

            <div class="flex flex-row">
                <a href="/" class="text-sky-500">Terug naar de homepagina</a>
            </div>
        </div>
    </div>
</template>
